<script context="module">
    import { readable, writable } from 'svelte/store';
    import { env } from './Environment.svelte';

    var storeToLoad = env.cleanstore;
    storeToLoad.dateLoaded = new Date();
    var localStoredStore = null;
    try {
        try {
            localStoredStore = localStorage.getItem('izzimx-store');
        } catch {}

        if (localStoredStore != null) {
            var recoveredStore = JSON.parse(localStoredStore);
            if (recoveredStore.dateLoaded != null) {
                recoveredStore.dateLoaded = new Date(recoveredStore.dateLoaded);
                let enlapsedTime =
                    (new Date() - recoveredStore.dateLoaded) / 1000;
                if (enlapsedTime < 7200) {
                    // Store offer for 2 hours
                    storeToLoad = recoveredStore;
                    if (storeToLoad.finalizedDate != null) {
                        storeToLoad.finalizedDate = new Date(
                            storeToLoad.finalizedDate
                        );
                    }
                }
            }
        }
    } catch {}

    export const store = writable(storeToLoad);
    store.subscribe((value) => {
        try {
            localStorage.setItem('izzimx-store', JSON.stringify(value));
        } catch {}
    });

    var storeToLoad_offer = env.cleanstore_offer;

    try {
        var localStoredStore_offer = null;
        try {
            localStoredStore_offer = localStorage.getItem('izzimx-store-offer');
        } catch {}
        if (localStoredStore_offer != null) {
            var storeToLoad_offer_recovered = JSON.parse(
                localStoredStore_offer
            );
            if (storeToLoad_offer_recovered.dateLoaded != null) {
                storeToLoad_offer_recovered.dateLoaded = new Date(
                    storeToLoad_offer_recovered.dateLoaded
                );
                let enlapsedTime =
                    (new Date() - storeToLoad_offer_recovered.dateLoaded) /
                    1000;
                if (enlapsedTime < 7200) {
                    // Store offer for 2 hours
                    storeToLoad_offer = storeToLoad_offer_recovered;
                    if (storeToLoad_offer.loadedOffer == null) {
                        storeToLoad_offer.loadedOffer = {};
                    }
                }
            }
        }
    } catch (error) {
        console.log(error);
    }

    export const store_offer = writable(storeToLoad_offer);
    store_offer.subscribe((value) => {
        try {
            localStorage.setItem('izzimx-store-offer', JSON.stringify(value));
        } catch {}
    });

    var storeToLoad_init_offer = env.cleanstore_offer;

    try {
        var localStoredStore_init_offer = null;
        try {
            localStoredStore_init_offer = localStorage.getItem(
                'izzimx-init-store-offer'
            );
        } catch {}
        if (localStoredStore_init_offer != null) {
            var storeToLoad_offer_init_recovered = JSON.parse(
                localStoredStore_init_offer
            );
            if (storeToLoad_offer_init_recovered.dateLoaded != null) {
                storeToLoad_offer_init_recovered.dateLoaded = new Date(
                    storeToLoad_offer_init_recovered.dateLoaded
                );
                let enlapsedTime =
                    (new Date() - storeToLoad_offer_init_recovered.dateLoaded) /
                    1000;
                if (enlapsedTime < 7200) {
                    // Store offer for 2 hours
                    storeToLoad_init_offer = storeToLoad_offer_init_recovered;
                    if (storeToLoad_init_offer.loadedOffer == null) {
                        storeToLoad_init_offer.loadedOffer = {};
                    }
                }
            }
        }
    } catch (error) {
        console.log(error);
    }

    export const store_init_offer = writable(storeToLoad_init_offer);
    store_init_offer.subscribe((value) => {
        try {
            localStorage.setItem(
                'izzimx-init-store-offer',
                JSON.stringify(value)
            );
        } catch {}
    });

    export const isStep5Or6 = writable(false);

    export const triggerValidation = writable(false);

    export const goBack = writable(false);

    export const totalPayment = writable(null);

    export const shouldVerifyPromotions = writable(false);

    export const isVerifyingPromotions = writable(
        window.location.href.includes('compra/configura')
    );

    export const isDisabled = writable(false);
</script>
